import { render, staticRenderFns } from "./entry.vue?vue&type=template&id=63080f12&scoped=true"
import script from "./entry.vue?vue&type=script&lang=js"
export * from "./entry.vue?vue&type=script&lang=js"
import style0 from "./entry.vue?vue&type=style&index=0&id=63080f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63080f12",
  null
  
)

export default component.exports